// import { assert } from '@/core'
import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class LogsService extends BaseService {
  static get entity() {
    return 'logs'
  }

  static async getById({ logId }) {
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/${logId}`)

      const data = {
        content: response.data,
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async getList(params = {}) {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}?${this.querystring(params)}`
      )

      const data = {
        content: response.data.data,
        total: response.data.total,
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async solve({ logId }) {
    try {
      const response = await this.request({ auth: true }).patch(`${this.entity}/${logId}`)

      const data = {
        content: response.data,
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async unsolvedCount() {
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/unsolved-count`)

      const data = {
        content: response.data.count,
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
